import React, { HTMLAttributes } from 'react';
import Tooltip from 'vibo-ui/Tooltip';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { DELAY_TO_SHOW_SONG_INFO } from './constants';

import { SongArtistNamesProps } from './interfaces';

import useStyles from './style';

const SongArtistNames = <T extends SongBase>({
  song,
  className,
  divideWithHyphen,
  onClick,
}: SongArtistNamesProps<T> & HTMLAttributes<HTMLDivElement>) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Tooltip
      overlay={
        <div className={classes.extraInfoTooltipContent}>
          <div className="label">
            {`${t('song')}:`}
            <span className="songName">{song?.title || '-'}</span>
          </div>
          <div className="label">
            {`${t('artist')}:`}
            <span className="songName">{song?.artist || '-'}</span>
          </div>
        </div>
      }
      mouseEnterDelay={DELAY_TO_SHOW_SONG_INFO}
      type="primary"
      placement="top"
      className={classes.extraInfoTooltip}
    >
      <div
        className={classNames('songArtistNames', classes.songArtistNames, className, {
          clickable: !!onClick,
        })}
        onClick={onClick}
        role="button"
      >
        {divideWithHyphen ? (
          <div className={classNames('songName artistName')}>{`${song?.title} ${
            !!song?.artist ? `- ${song?.artist}` : ''
          }`}</div>
        ) : (
          <>
            <div className={classNames('songName', classes.songName)}>{song?.title}</div>
            <div className={classNames('artistName', classes.artistName)}>{song?.artist}</div>
          </>
        )}
      </div>
    </Tooltip>
  );
};

export default SongArtistNames;
